import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Get Challenge Types
  challengeTypes: [],
  challengeTypesSuccess: false,
  challengeTypesError: null,
  challengeTypesLoading: false,

  //get currencies
  currencies: [],
  currenciesSuccess: false,
  currenciesError: null,
  currenciesLoading: false,

  //get platforms
  platforms: [],
  platformsSuccess: false,
  platformsError: null,
  platformsLoading: false,

  //get challenge info
  challengeInfo: {},
  challengeInfoSuccess: false,
  challengeInfoError: null,
  challengeInfoLoading: false,

  //create Challenge
  createChallengeSuccess: false,
  createChallengeError: null,
  createChallengeLoading: false,

  //create draft
  createDraftSuccess: false,
  createDraftError: null,
  createDraftLoading: false,

  //continue draft
  continueDraftSuccess: false,
  continueDraftError: null,
  continueDraftLoading: false,

  // get addons
  addons: [],
  addonsSuccess: false,
  addonsError: null,
  addonsLoading: false,

  //init payabl payment
  payablePayment: {},
  payablePaymentError: null,
  payablePaymentSuccess: false,
  payablePaymentLoading: false,

  //check promo
  checkPromoSuccess: false,
  checkPromoError: null,
  checkPromoLoading: false,
  checkPromo: {},

  //affiliate tracking
  affiliateTrackingSuccess: false,
  affiliateTrackingError: null,
  affiliateTrackingLoading: false,
};

const ChallengeSetupReducer = createSlice({
  name: "Challenge Setup",
  initialState,
  reducers: {
    // Get Challenge Types
    getChallengeTypesRequest: (state) => {
      state.challengeTypesLoading = true;
      state.challengeTypesError = null;
      state.challengeTypesSuccess = false;
      state.challengeTypes = [];
    },
    getChallengeTypesSuccess: (state, { payload }) => {
      state.challengeTypes = payload;
      state.challengeTypesLoading = false;
      state.challengeTypesError = null;
      state.challengeTypesSuccess = true;
    },
    getChallengeTypesError: (state, { payload }) => {
      state.challengeTypesLoading = false;
      state.challengeTypesError = payload;
      state.challengeTypesSuccess = false;
      state.challengeTypes = [];
    },

    //get currencies
    getCurrenciesRequest: (state) => {
      state.currenciesLoading = true;
      state.currenciesError = null;
      state.currenciesSuccess = false;
      state.currencies = [];
    },
    getCurrenciesSuccess: (state, { payload }) => {
      state.currencies = payload;
      state.currenciesLoading = false;
      state.currenciesError = null;
      state.currenciesSuccess = true;
    },
    getCurrenciesError: (state, { payload }) => {
      state.currenciesLoading = false;
      state.currenciesError = payload;
      state.currenciesSuccess = false;
      state.currencies = [];
    },

    //get platforms
    getPlatformsRequest: (state) => {
      state.platformsLoading = true;
      state.platformsError = null;
      state.platformsSuccess = false;
      state.platforms = [];
    },
    getPlatformsSuccess: (state, { payload }) => {
      state.platforms = payload;
      state.platformsLoading = false;
      state.platformsError = null;
      state.platformsSuccess = true;
    },
    getPlatformsError: (state, { payload }) => {
      state.platformsLoading = false;
      state.platformsError = payload;
      state.platformsSuccess = false;
      state.platforms = [];
    },

    //get challenge info
    getChallengeInfoRequest: (state) => {
      state.challengeInfoLoading = true;
      state.challengeInfoError = null;
      state.challengeInfoSuccess = false;
      state.challengeInfo = {};
    },
    getChallengeInfoSuccess: (state, { payload }) => {
      state.challengeInfo = payload;
      state.challengeInfoLoading = false;
      state.challengeInfoError = null;
      state.challengeInfoSuccess = true;
    },
    getChallengeInfoError: (state, { payload }) => {
      state.challengeInfoLoading = false;
      state.challengeInfoError = payload;
      state.challengeInfoSuccess = false;
      state.challengeInfo = {};
    },

    //create Challenge
    createChallengeRequest: (state) => {
      state.createChallengeLoading = true;
      state.createChallengeError = null;
      state.createChallengeSuccess = false;
    },
    createChallengeSuccess: (state, { payload }) => {
      state.createChallengeLoading = false;
      state.createChallengeError = null;
      state.createChallengeSuccess = true;
    },
    createChallengeError: (state, { payload }) => {
      state.createChallengeLoading = false;
      state.createChallengeError = payload;
      state.createChallengeSuccess = false;
    },

    //create draft
    createDraftRequest: (state) => {
      state.createDraftLoading = true;
      state.createDraftError = null;
      state.createDraftSuccess = false;
    },
    createDraftSuccess: (state, { payload }) => {
      state.createDraftLoading = false;
      state.createDraftError = null;
      state.createDraftSuccess = payload;
    },
    createDraftError: (state, { payload }) => {
      state.createDraftLoading = false;
      state.createDraftError = payload;
      state.createDraftSuccess = false;
    },

    //continue draft
    continueDraftRequest: (state) => {
      state.continueDraftLoading = true;
      state.continueDraftError = null;
      state.continueDraftSuccess = false;
    },
    continueDraftSuccess: (state, { payload }) => {
      state.continueDraftLoading = false;
      state.continueDraftError = null;
      state.continueDraftSuccess = true;
    },
    continueDraftError: (state, { payload }) => {
      state.continueDraftLoading = false;
      state.continueDraftError = payload;
      state.continueDraftSuccess = false;
    },

    // get addons
    getAddonsRequest: (state) => {
      state.addonsLoading = true;
      state.addonsError = null;
      state.addonsSuccess = false;
      state.addons = [];
    },
    getAddonsSuccess: (state, { payload }) => {
      state.addons = payload;
      state.addonsLoading = false;
      state.addonsError = null;
      state.addonsSuccess = true;
    },
    getAddonsError: (state, { payload }) => {
      state.addonsLoading = false;
      state.addonsError = payload;
      state.addonsSuccess = false;
      state.addons = [];
    },

    //init payable payment
    initPayablePaymentRequest: (state) => {
      state.payablePaymentLoading = true;
      state.payablePaymentError = null;
      state.payablePaymentSuccess = false;
      state.payablePayment = {};
    },
    initPayablePaymentSuccess: (state, { payload }) => {
      state.payablePayment = payload;
      state.payablePaymentLoading = false;
      state.payablePaymentError = null;
      state.payablePaymentSuccess = true;
    },
    initPayablePaymentError: (state, { payload }) => {
      state.payablePaymentLoading = false;
      state.payablePaymentError = payload;
      state.payablePaymentSuccess = false;
      state.payablePayment = {};
    },

    //check promo
    checkPromoRequest: (state) => {
      state.checkPromoLoading = true;
      state.checkPromoError = null;
      state.checkPromoSuccess = false;
      state.checkPromo = {};
    },
    checkPromoSuccess: (state, { payload }) => {
      state.checkPromo = payload;
      state.checkPromoLoading = false;
      state.checkPromoError = null;
      state.checkPromoSuccess = true;
    },
    checkPromoError: (state, { payload }) => {
      state.checkPromoLoading = false;
      state.checkPromoError = payload;
      state.checkPromoSuccess = false;
      state.checkPromo = {};
    },

    //clear promo
    clearPromo: (state) => {
      state.checkPromoSuccess = false;
      state.checkPromoError = null;
      state.checkPromo = {};
    },

    //affiliate tracking
    affiliateTrackingRequest: (state) => {
      state.affiliateTrackingLoading = true;
      state.affiliateTrackingError = null;
      state.affiliateTrackingSuccess = false;
    },
    affiliateTrackingSuccess: (state, { payload }) => {
      state.affiliateTrackingLoading = false;
      state.affiliateTrackingError = null;
      state.affiliateTrackingSuccess = true;
    },
    affiliateTrackingError: (state, { payload }) => {
      state.affiliateTrackingLoading = false;
      state.affiliateTrackingError = payload;
      state.affiliateTrackingSuccess = false;
    },

    //clear states
    clearStates: (state) => {
      // Get Challenge Types
      state.challengeTypesSuccess = false;
      state.challengeTypesError = null;

      //get currencies
      state.currenciesSuccess = false;
      state.currenciesError = null;

      //get platforms
      state.platformsSuccess = false;
      state.platformsError = null;

      //get challenge info
      state.challengeInfoSuccess = false;
      state.challengeInfoError = null;

      //create Challenge
      state.createChallengeSuccess = false;
      state.createChallengeError = null;

      //create draft
      state.createDraftSuccess = false;
      state.createDraftError = null;

      //continue draft
      state.continueDraftSuccess = false;
      state.continueDraftError = null;

      // get addons
      state.addonsSuccess = false;
      state.addonsError = null;

      //init payabl payment
      state.payablePaymentSuccess = false;
      state.payablePaymentError = null;

      //check promo
      state.checkPromoSuccess = false;
      state.checkPromoError = null;

      //affiliate tracking
      state.affiliateTrackingSuccess = false;
      state.affiliateTrackingError = null;
    },
  },
});
export const ChallengeSetupActions = ChallengeSetupReducer.actions;

export default ChallengeSetupReducer.reducer;
